
import React from "react";
import { TypeOperationEnum, typeOperationLabels } from "./MasterDataTypes";


type TypeOperationCheckboxListProps = {
    selectedOperations: TypeOperationEnum[];
    onChange: (operations: TypeOperationEnum[]) => void;
};

const TypeOperationCheckboxList: React.FC<TypeOperationCheckboxListProps> = ({ selectedOperations, onChange }) => {
    const handleCheckboxChange = (operation: TypeOperationEnum) => {
        if (selectedOperations.includes(operation)) {
            onChange(selectedOperations.filter((op) => op !== operation));
        } else {
            onChange([...selectedOperations, operation]);
        }
    };

    return (
        <div style={{ display: "flex", gap: "10px" }}>
            {Object.values(TypeOperationEnum).map((operation) => (
                <label key={operation} style={{ display: "flex", alignItems: "center" }}>
                    <input
                        type="checkbox"
                        checked={selectedOperations.includes(operation)}
                        onChange={() => handleCheckboxChange(operation)}
                    />
                    <span style={{ marginLeft: "5px" }}>{typeOperationLabels[operation]}</span>
                </label>
            ))}
        </div>
    );
};

export default TypeOperationCheckboxList;
